export var SearchSize;
(function (SearchSize) {
    SearchSize["SM"] = "sm";
    SearchSize["MD"] = "md";
    SearchSize["LG"] = "lg";
})(SearchSize || (SearchSize = {}));
